module.exports = __webpack_public_path__ + "project1-header.svg?416279ef21b0048d396e83ca21562315";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/project1-header.svg
// module id = 333
// module chunks = 0